import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';
import './Login.css';
import { authService } from '../services/AuthService';
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

const schema = yup.object().shape({
    identificationNumber: yup.string().required('El numero de local es requerido'),
    username: yup.string().required('El usuario es requerido'),
    password: yup.string().required('La contraseña es requerida')
});

export default function Login() {
    const navigate = useNavigate();
    const versionApp = "V1.3.1";
    const [isLoading, setIsLoading] = useState(false);
    const [loginAttempts, setLoginAttempts] = useState(0);
    const [isRateLimited, setIsRateLimited] = useState(false);

    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(schema)
    });

    useEffect(() => {
        document.title = 'QReate - Login';
        // Verificar si el usuario ya está autenticado
        if (authService.isAuthenticated()) {
            navigate('/home');
        }
    }, [navigate]);

    const onSubmit = async (data) => {
        if (isRateLimited) {
            toast.error('Demasiados intentos. Por favor, espere un momento');
            return;
        }

        setIsLoading(true);
        try {
            await authService.login(data.identificationNumber, data.username, data.password);
            navigate('/home');
        } catch (error) {
            setLoginAttempts(prev => prev + 1);
            if (loginAttempts >= 3) {
                setIsRateLimited(true);
                setTimeout(() => {
                    setIsRateLimited(false);
                    setLoginAttempts(0);
                }, 30000); // 30 segundos de bloqueo
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className='body' style={{backgroundImage: 'url("../fondoNew.png")'}}>
            <div className='loginContainer'>
                <div className='centerLogin'>
                    <div className="login">
                        <img src={process.env.PUBLIC_URL + '/imgLogin.png'} alt="QReate" className='imgLogin'/>
                    
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <p className='textCampos'>Numero de local</p>
                            <input 
                                className={`inputLogin ${errors.identificationNumber ? 'input-error' : ''}`}
                                type="number"
                                {...register('identificationNumber')}
                            />
                            {errors.identificationNumber && (
                                <p className="error-message">{errors.identificationNumber.message}</p>
                            )}

                            <p className='textCampos'>Usuario</p>
                            <input
                                className={`inputLogin ${errors.username ? 'input-error' : ''}`}
                                type="text"
                                {...register('username')}
                            />
                            {errors.username && (
                                <p className="error-message">{errors.username.message}</p>
                            )}
                            
                            <p className='textCampos'>Contraseña</p>
                            <input 
                                className={`inputLogin ${errors.password ? 'input-error' : ''}`}
                                type="password"
                                {...register('password')}
                            />
                            {errors.password && (
                                <p className="error-message">{errors.password.message}</p>
                            )}
                            
                            <button 
                                type="submit" 
                                className="btnIngresar btn"
                                disabled={isLoading || isRateLimited}
                            >
                                {isLoading ? 'Ingresando...' : 'Ingresar'}
                            </button>
                        </form>
                        <p className='version'>{versionApp}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}